export default __webpack_public_path__ + "static/media/programme-arrow.b9ace9d5.png";